module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("DropDown")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('dropdown', {
    attrs: {
      "dropdownId": "drop-phones",
      "options": _vm.dropdownOptions,
      "value": _vm.selectedValue,
      "customClass": "large label",
      "iconProperty": _vm.iconProperty
    },
    on: {
      "update:value": function($event) {
        _vm.selectedValue = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui buttons"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.changeToOnlyIcons
    }
  }, [_vm._v("Only Icons")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.changeToOnlyText
    }
  }, [_vm._v("Only Text")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.changeToIconsAndText
    }
  }, [_vm._v("Icons and Text")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.changeOptions
    }
  }, [_vm._v("Change options")])]), _vm._v(" "), _c('h4', {
    staticClass: "ui header"
  }, [_vm._v("SelectedValue")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_vm._v(_vm._s(_vm.selectedValue))]), _vm._v(" "), _c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Options Array")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_vm._v(_vm._s(_vm.dropdownOptions))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Props")]), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Dropdown component,\n        "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/dropdown.html"
    }
  }, [_vm._v(" you can see all documentation here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment dropdown-code"
  }, [_c('pre', [_vm._v("\n            import { Dropdown } from 'semvue';\n\n            export default {\n                components: {\n                    Dropdown,\n                },\n            }\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment dropdown-code"
  }, [_c('pre', [_vm._v("\n            <dropdown dropdownId=\"drop-phones\" \n                :options=\"dropdownOptions\" \n                :value.sync=\"selectedValue\" \n                customClass=\"large label\" \n                :iconProperty=\"iconProperty\">\n            </dropdown>\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui definition table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("dropdownId")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Is a div id for dropdown")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Used to control current selected value")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("iconProperty")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String Empty")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("If you option has any icon to show, or the dropdown it self is made by icons, this prop defines wich property inside option contains the icon class")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment dropdown-code"
  }, [_c('pre', [_vm._v("\n    e.g.: iconProperty=\"iconClassProperty\"\n    option: { iconClassProperty: 'myIconClass' value: 0 };\n    this will render: <i class=\"myIconClass icon`\"></i>\n                            ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("curstomClass")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String empty")]), _vm._v(" "), _c('td', [_vm._v("Used to put any aditional class inside rating div "), _c('br'), _vm._v("\n                    e.g. class=\"ui customClass dropdown\"\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-765ee502"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropdownDoc.vue
// module id = 152
// module chunks = 1